import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { BRAND } from "@/lib/brand";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      nav("/account");
    } catch (err) { setError(apiError(err.response?.data?.detail) || "Registration failed"); }
    finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 sm:px-6 py-20">
      <div className="text-center mb-8">
        <img src={BRAND.logoCircle} alt="APE-TIDES" className="h-20 w-20 object-contain mx-auto mb-4" />
        <h1 className="font-display text-4xl tracking-tight">JOIN THE TRIBE</h1>
        <p className="text-ape-muted text-sm mt-2">Built different. Evolve beyond limits.</p>
      </div>
      <form onSubmit={submit} className="border border-ape-border bg-ape-surface p-8 space-y-6" data-testid="register-form">
        {error && <div className="border border-ape-red bg-ape-red/10 text-ape-red text-sm p-3 font-mono2" data-testid="register-error">{error}</div>}
        {[["Full Name", "name", "text"], ["Email", "email", "email"], ["Password", "password", "password"]].map(([l, k, t]) => (
          <label key={k} className="block">
            <span className="font-mono2 text-[10px] tracking-widest text-ape-muted">{l.toUpperCase()}</span>
            <input type={t} required value={form[k]} onChange={set(k)} data-testid={`register-${k}`}
              className="w-full bg-transparent border-b-2 border-ape-border rounded-none py-2 text-white focus:border-ape-red focus:outline-none transition-colors duration-150" />
          </label>
        ))}
        <button disabled={loading} className="w-full bg-ape-red hover:bg-ape-redhover disabled:opacity-50 text-white font-head uppercase tracking-widest py-4 transition-colors duration-150" data-testid="register-submit">
          {loading ? "Creating..." : "Create Account"}
        </button>
      </form>
      <p className="text-center text-ape-muted text-sm mt-6">Already a member? <Link to="/login" className="text-ape-red hover:text-white transition-colors duration-150" data-testid="to-login">Log in</Link></p>
    </div>
  );
}
